import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { CONTROLLERS: { SCHEDULE_DOWNLOAD_DOC: { BASE, VERSION } } } = USER;
const { METHOD: { GET } } = HOOKS_SETTINGS;

export const useDownloadScheduleCQuery = ({ customerId, scheduleCId, onSuccess }: {customerId: string, scheduleCId: string, onSuccess?: (doc: any) => void}) => useQuery(
  ['DownloadScheduleC'],
  async () => {
    if (!customerId || !scheduleCId) {
      return '';
    }
    try {
      const { data } = await httpService({
        url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${scheduleCId}`,
        method: GET,
        responseType: 'blob',
      });
      return URL.createObjectURL(data);
    } catch (e) {
      if (!process.env.TESTING) console.error(e);
      return '';
    }
  },
  {
    enabled: false,
    onSuccess: (doc) => { if (onSuccess) onSuccess(doc); },
  },
);
